import { X, XIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { connectionActions } from "../../../store/slices/connectionSlice";

const Connection = ({ from, to, id, vehicle: vehicleProp, driver: driverProp, onDelete }) => {
  const [vehicle, setVehicle] = useState(vehicleProp ?? "");
  const [driver, setDriver] = useState(driverProp ?? "");
  const dispatch = useDispatch();

  const fromCenter = { x: from.x + 25, y: from.y + 25 };
  const toCenter = { x: to.x + 25, y: to.y + 25 };

  const deltaX = toCenter.x - fromCenter.x;
  const deltaY = toCenter.y - fromCenter.y;
  const length = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
  const angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI);

  const midX = fromCenter.x + deltaX / 2;
  const midY = fromCenter.y + deltaY / 2;

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete?.(id);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (vehicle.trim().length > 0 && id) {
        dispatch(
          connectionActions.updateConnectionVehiclePut({
            payload: { vehicle },
            id,
          })
        );
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [vehicle, dispatch, id]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (driver.trim().length > 0 && id) {
        dispatch(
          connectionActions.updateConnectionDriverPut({
            payload: { driver },
            id,
          })
        );
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [driver, dispatch, id]);

  return (
    <>
      <div
        style={{
          position: "absolute",
          left: fromCenter.x,
          top: fromCenter.y,
          width: length,
          height: 2,
          backgroundColor: "black",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
          transformOrigin: "0 50%",
          transform: `rotate(${angle}deg)`,
          pointerEvents: "none",
          zIndex: 1,
        }}
      >
        <div
          style={{
            position: "absolute",
            width: 0,
            height: 0,
            borderLeft: "4px solid transparent",
            borderRight: "4px solid transparent",
            borderBottom: "4px solid #4B5563",
            right: -4,
            top: -1,
            transform: "translateY(-50%)",
          }}
        />
      </div>

      <input
        type="text"
        value={vehicle}
        onChange={(e) => setVehicle(e.target.value)}
        placeholder="Vozilo"
        style={{
          position: "absolute",
          width: "6rem",
          height: "2rem",
          fontSize: "0.75rem",
          paddingLeft: "0.5rem",
          paddingRight: "0.5rem",
          paddingTop: "0.2rem",
          paddingBottom: "0.25rem",
          backgroundColor: "#ffffff",
          border: "1px solid #D1D5DB",
          borderRadius: "0.25rem",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
          zIndex: 10,
          textAlign: "center",
          left: midX - 48,
          top: midY - 45,
        }}
      />

      <button
        onClick={handleDelete}
        style={{
          position: "absolute",
          left: midX - 12,
          top: midY - 12,
          width: 24,
          height: 24,
          backgroundColor: "#EF4444",
          color: "#FFFFFF",
          borderRadius: "9999px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          cursor: "pointer",
          transition: "background-color 0.2s ease-in-out",
          zIndex: 10,
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#DC2626";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#EF4444";
        }}
        title="Delete connection"
      >
        <XIcon color="black" />
      </button>
      <input
        type="text"
        placeholder="Vozač"
        value={driver}
        onChange={(e) => setDriver(e.target.value)}
        style={{
          position: "absolute",
          width: "6rem",
          height: "2rem",
          fontSize: "0.75rem",
          paddingLeft: "0.5rem",
          paddingRight: "0.5rem",
          paddingTop: "0.25rem",
          paddingBottom: "0.25rem",
          textAlign: "center",
          backgroundColor: "#ffffff",
          border: "1px solid #D1D5DB",
          borderRadius: "0.25rem",
          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
          zIndex: 10,
          left: midX - 48,
          top: midY + 15,
        }}
      />
    </>
  );
};

export default Connection;
